import type { CauseOfDeath } from "shared/types";

export const LIST_FARM_CAUSES_OF_DEATH = "LIST_FARM_CAUSES_OF_DEATH";

export type CauseOfDeathDispatchAction = {
  type: typeof LIST_FARM_CAUSES_OF_DEATH;
  payload: { causesOfDeath: CauseOfDeath[] };
};

export const listFarmCausesOfDeath = (
  causesOfDeath: CauseOfDeath[]
): CauseOfDeathDispatchAction => {
  return {
    type: LIST_FARM_CAUSES_OF_DEATH,
    payload: { causesOfDeath },
  };
};
